import React from 'react';

import Badge from '@mui/material/Badge';
import { createTheme } from '@mui/material/styles';
import { ThemeProvider } from '@mui/styles';

import { FullPalette } from '@grnhse/seedling/lib/birch/colors';

const badgeTheme = createTheme({
  palette: {
    primary: {
      main: FullPalette.ZINNIA_E200,
      contrastText: FullPalette.EVERGREEN_700,
    },
  },
});

type IconBadgeProps = { children: React.ReactNode } & React.ComponentProps<
  typeof Badge
>;

export const IconBadge = ({ children, ...otherProps }: IconBadgeProps) => (
  <ThemeProvider theme={badgeTheme}>
    <Badge color={'primary'} {...otherProps}>
      {children}
    </Badge>
  </ThemeProvider>
);

type DotBadgeProps = React.ComponentProps<typeof Badge>;

export const DotBadge = (props: DotBadgeProps) => (
  <Badge
    variant="dot"
    sx={{
      marginLeft: '8px',
      '& .MuiBadge-badge': {
        backgroundColor: FullPalette.ZINNIA_E300,
      },
    }}
    data-provides="unread-dot"
    {...props}
  />
);
